export const FLAT_RATE_SHIPPING_CENTS = 1500
export const FREE_SHIPPING_THRESHOLD_CENTS = 5000

const formatUSDWholeFromCents = (cents: number): string => `$${cents / 100}`

export const getEstimatedShippingCents = (subtotalCents: number): number =>
  subtotalCents >= FREE_SHIPPING_THRESHOLD_CENTS ? 0 : FLAT_RATE_SHIPPING_CENTS

export const getShippingPolicySummary = (): string =>
  `Free shipping on orders over ${formatUSDWholeFromCents(FREE_SHIPPING_THRESHOLD_CENTS)}.`

export const getShippingPolicyBrief = (): string => getShippingPolicySummary()

export const getShippingAndTaxCheckoutNote = (): string =>
  `${getShippingPolicySummary()} Tax calculated at checkout.`
